import { createFileRoute } from '@tanstack/react-router';
import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';
import { PublicIdInformationDetail } from './-components/PublicIdInformationDetail';
import { prefetchPublicIdInformationDetail } from './-query';
export const Route = createFileRoute('/_staff/person/$id/_profile/public-id/')({
  component: PublicIdInformation,
  loader: ({
    params
  }) => prefetchPublicIdInformationDetail(params.id)
});
function PublicIdInformation() {
  const {
    id
  } = usePersonParams();
  return <PublicIdInformationDetail personId={id} linkTo="/person/$id/public-id" />;
}